import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";

export default class TwitterLinkGenerator implements ShariffLinkGeneratorInterface {
    public generateLink(url: string): string {
        return "https://twitter.com/intent/tweet"
            + "?text=" + encodeURIComponent(url);
    }

}
